import { render, staticRenderFns } from "./ReadAloudCreateDetail.vue?vue&type=template&id=e88d1e3c&scoped=true&"
import script from "./ReadAloudCreateDetail.vue?vue&type=script&lang=js&"
export * from "./ReadAloudCreateDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReadAloudCreateDetail.vue?vue&type=style&index=0&id=e88d1e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88d1e3c",
  null
  
)

export default component.exports